import { ColorName } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import styles from "./CloseButton.module.css";

type CloseButtonProps = {
  onClose: () => void;
  label?: string;
  size?: number;
  color?: ColorName;
  ariaDescribedBy?: string;
};

const CloseButton = ({
  ariaDescribedBy,
  onClose,
  label = "Close sidebar",
  size = 28,
  color = "GrayWarm6",
}: CloseButtonProps) => {
  return (
    <button
      aria-describedby={ariaDescribedBy}
      style={{ height: size }}
      className={styles.closeButton}
      aria-label={label}
      onClick={onClose}
      type="button"
    >
      <Icon name="formX" size={size} color={color} />
    </button>
  );
};

export default CloseButton;
